import { render } from "./ViewHistoricoDescarga.vue?vue&type=template&id=6d5f50f2&scoped=true"
import script from "./ViewHistoricoDescarga.vue?vue&type=script&lang=js"
export * from "./ViewHistoricoDescarga.vue?vue&type=script&lang=js"

import "./ViewHistoricoDescarga.vue?vue&type=style&index=0&id=6d5f50f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5f50f2"]])

export default __exports__